import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { MeterpointService } from "@/services/MeterpointService"
import { MeterpointTariffs } from "@/types/MeterpointTariffs"

export const getAccountMeterpointTariffs = (accountNumber: string) => {
  const queries = new QueryAggregator()

  // Registered on the aggregator before it is read, so the aggregate stays
  // loading until the coreId resolves rather than reporting ready while the
  // tariff queries are still disabled and holding empty placeholder data.
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  queries.add(coreIdQuery)

  const meterpointsQuery = MeterpointService.getForAccount(accountNumber)
  queries.add(meterpointsQuery)

  const tariffAgreements = meterpointsQuery.data.reduce(
    (meterpointAgreementsMap, meterpoint) => {
      const tariffQuery = MeterpointService.getMeterpointTariffs(
        meterpoint.identifier,
        coreIdQuery.data,
      )

      const currentTariff = tariffQuery.data.currentTariff
      const compareTariffsQuery =
        currentTariff?.code && currentTariff.isVariable && meterpoint.gsp
          ? MeterpointService.getMonthlyTariffRateComparisons(
              meterpoint.gsp,
              currentTariff.code,
            )
          : undefined

      if (compareTariffsQuery) {
        queries.add(compareTariffsQuery)
      }

      queries.add(tariffQuery)

      meterpointAgreementsMap[meterpoint.identifier] = {
        ...tariffQuery.data,
        meterpoint: meterpoint,
        monthlyRateComparison: compareTariffsQuery?.data,
      }

      return meterpointAgreementsMap
    },
    {} as MeterpointTariffs,
  )

  return queries.setData(tariffAgreements).getAggregate()
}
